import React, { useEffect, useRef, useState } from "react";
import NavbarSection from "./Navbar";
import Sidebar from "./Sidebar";
import FooterSection from "./Footer";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ResetGlobalState } from "../../../redux/auth/authSlice";
import { ResetGlobalStateRequestAuthSlice } from "../../../redux/auth/RequestsAuthSlice";
import CustomChatButton from "../CustomTawk";

// S-21: hoist the listener list out of the component body so its identity
// is stable across renders.
const IDLE_EVENTS = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];
const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 min

// S-52: single source of truth for public paths. Guarded routes are
// enforced at the Router level via <RequireAuth> (S-12).
const PUBLIC_PATHS = new Set([
  "/",
  "/login",
  "/signup",
  "/otp",
  "/verifyotp",
  "/forgotpassword",
  "/resetpassword",
  "/termsandconditions",
  "/privacypolicy",
  "/qrcode",
  "/auth/callback",
  "/tiktokredirect",
  "/payment",
  "/success",
  "/failed",
]);

const UserLayout = ({ children }) => {
  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timerRef = useRef(null);

  const HandleToggle = () => setToggle((t) => !t);

  // S-21: a single effect wires up idle-logout listeners with a stable
  // dependency list and a real cleanup function. `timerRef` persists across
  // renders so we never leak timers.
  useEffect(() => {
    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        if (localStorage.getItem("access_token")) {
          localStorage.clear();
          sessionStorage.clear();
          dispatch(ResetGlobalState());
          dispatch(ResetGlobalStateRequestAuthSlice());
          navigate("/");
        }
      }, IDLE_TIMEOUT_MS);
    };

    IDLE_EVENTS.forEach((e) => window.addEventListener(e, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      IDLE_EVENTS.forEach((e) => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dispatch, navigate]);

  useEffect(() => {
    document.body.classList.remove("open-class");
    const id = setTimeout(() => {
      if (toggle) document.body.classList.add("open-class");
    }, 250);
    return () => clearTimeout(id);
  }, [toggle]);

  const isPublic = PUBLIC_PATHS.has(location.pathname);

  if (isPublic) {
    return (
      <>
        <CustomChatButton />
        {children}
      </>
    );
  }

  return (
    <>
      <CustomChatButton />
      <NavbarSection HandleToggle={HandleToggle} toggle={toggle} />
      <Sidebar HandleToggle={HandleToggle} toggle={toggle} />
      <section className="dasboard-all pages">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="content-dasboard">{children}</div>
            </div>
          </div>
        </div>
      </section>
      <FooterSection toggle={toggle} />
    </>
  );
};

export default UserLayout;
